type AdminEnv = {
  supabaseUrl: string;
  publishableKey: string;
  frontendUrl: string;
};

function readRequired(name: "VITE_SUPABASE_URL" | "VITE_SUPABASE_PUBLISHABLE_KEY") {
  const value = import.meta.env[name]?.trim();
  if (!value) throw new Error(`missing_${name.toLowerCase()}`);
  return value;
}

let cached: AdminEnv | null = null;

export function getEnv(): AdminEnv {
  if (cached) return cached;
  const supabaseUrl = readRequired("VITE_SUPABASE_URL");
  const publishableKey = readRequired("VITE_SUPABASE_PUBLISHABLE_KEY");
  const frontendUrl = import.meta.env.VITE_FRONTEND_URL?.trim() || "http://127.0.0.1:3000";
  cached = { supabaseUrl, publishableKey, frontendUrl };
  return cached;
}
